import { api } from '@/services/api/AxiosBaseService'

export interface IdName { id: string; name: string }

export interface ProviderBeneficiary {
  name: string
  cpf: string
  birthDate: string
  type: string
  plan: string
  product: string
  company: string
}

/** Relatório de Provedores (wizard) — Comercial > Relatórios > Provedores. */
export const ProviderReportsService = {
  async providers(): Promise<IdName[]> {
    const r = await api.get<{ data: IdName[] }>('/commercial/reports/providers')
    return r.data.data
  },
  async types(providerId: string): Promise<IdName[]> {
    const r = await api.get<{ data: IdName[] }>('/commercial/reports/providers/types', { params: { provider_id: providerId } })
    return r.data.data
  },
  async services(providerId: string): Promise<IdName[]> {
    const r = await api.get<{ data: IdName[] }>('/commercial/reports/providers/services', { params: { provider_id: providerId } })
    return r.data.data
  },
  async products(providerId: string, typeIds: string[], serviceIds: string[]): Promise<IdName[]> {
    const r = await api.get<{ data: IdName[] }>('/commercial/reports/providers/products', {
      params: { provider_id: providerId, type_ids: typeIds, service_ids: serviceIds },
    })
    return r.data.data
  },
  async beneficiaries(payload: { type_ids: string[]; product_ids: string[] }): Promise<ProviderBeneficiary[]> {
    const r = await api.post<{ data: ProviderBeneficiary[] }>('/commercial/reports/providers/beneficiaries', payload)
    return r.data.data
  },
}
